/** @format */

import { Paper, Grid, Typography, CircularProgress } from '@mui/material';
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Icons } from 'components';
import { makeStyles } from '@mui/styles';
// TODO: add this component to ~/components folder to use globaly
import clsx from 'clsx';

export default function UploadDoc({ acceptsFile, file, setFile, disabled, onHandleChange, fileSize, maxSize, acceptsList }) {
  // --STAETS--//

  // --OTHER FUNCTIONS--//
  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles[0]);
    if (onHandleChange) {
      onHandleChange(acceptedFiles[0])
    }
    acceptedFiles.forEach(file => {
      fileSize = file.size
    });

  }, []);

  // --HOOKS--//
  const classes = useStyles();
  const { getRootProps, getInputProps, isDragActive = true } = useDropzone({ onDrop });

  return (
    <Paper className={clsx(classes.uploadPaper, isDragActive ? 'activeDerag' : '')}
      elevation={0}>
      <div {...getRootProps()}>
              {/* <Backdrop open={disabled} className={classes.backdrop} /> */}

        <input
          {...getInputProps()}
          multiple={false}
          accept={acceptsFile}
          disabled={disabled}
        />
        <Grid justifyContent="center" container direction="column" item xs={12} style={disabled ? { visibility: 'hidden' } : {}}>
          <Grid justifyContent="center" container item xs={12}>
            {file ? (
              <Typography className={classes.fileFormat} variant="h5" align="center">
                {`.${file?.name?.split('.').pop()}`}asasas
              </Typography>
            ) : isDragActive ? (
              <div className={classes.uploadIcon}>
                <Icons icon='Drag' color='#667585' hover='#667585' size='28' />
              </div>) : (
              <div className={classes.uploadIcon}>
                <Icons icon='Upload' color='#667585' hover='#667585' size='28' />
              </div>
            )}
          </Grid>
          <Grid justifyContent="center" container item xs={12} style={{ flexDirection: 'column' }}>
            <Typography className={classes.dragHereText} variant="h5" align="center" >
              <p className={classes.dragHereTextDesc} ><b className={classes.dragHereTextBold}>برای آپلود کلیک کنید</b> یا بکشید و رها کنید </p>
            </Typography>
            <Typography className={classes.showFormat} variant="h5" align="center">
              (حداکثر {maxSize} مگابایت) {acceptsList}
            </Typography>
          </Grid>
        </Grid>
      </div>
      {
        disabled &&
        <div style={{ position: 'absolute', width: '100%', height: '100%', top: '0', right: '0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress size={28} className={classes.buttonProgress} />
        </div>
      }
    </Paper>
  );
}

const useStyles = makeStyles((theme) => {
  return {
    uploadPaper: {
      position: 'relative',
      background: '#fff',
      border: `2px solid #E2E5E9`,
      padding: '23px 32px',
      boxSizing: 'border-box',
      borderRadius: 10,
      cursor: 'pointer',
      width: '460px',
      overflow: 'hidden',
      transitionDuration: '0.5ms',
      boxShadow: '0px 1px 2px 0px #1018280D',
      flexDirection: 'column',
      '@media(max-width: 600px)': {
        width: '100%',
      },
      '&:hover': {
        border: `2px solid #2B3990`,
        transitionDuration: '0.5ms',
      },
      '&.activeDerag': {
        border: `2px solid #2B3990`,
        transitionDuration: '0.5ms',

      },
      '& *': {
        outline: 'none',
      },
    },
    uploadIcon: {
      width: '50px',
      height: '50px',
      textAlign: 'center',
      lineHeight: '68px',
      borderRadius: '9px',
      border: '2px solid #EEF0F2',
    },
    dragHereIcon: {
      fontSize: 50,
      color: theme.palette.grey[600],
    },
    dragHereText: {
      paddingTop: theme.spacing(2),
      fontFamily: 'Vazir',
      fontSize: '13px'
    },
    dragHereTextDesc: {
      fontWeight: '400',
      color: '#667585'
    },
    dragHereTextBold: {
      color: '#0369CD',
      fontWeight: '700'

    },
    showFormat: {
      direction: 'rtl',
      fontSize: 13,
      marginTop: '4px',
      fontWeight: '400',
      color: '#667585',
    },
    fileFormat: {
      direction: 'rtl',
      fontSize: 40,
      marginBottom: 13,
      marginTop: 5,
      color: theme.palette.grey[600],
    },
    backdrop: {
      background: theme.palette.grey[100],
    },
  };
});


